import React, { useEffect, useState } from "react";
import PublicLayout from "../../components/PublicLayout";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../../components/ui/accordion";
import api from "../../lib/api";

export default function FAQ() {
  const [faq, setFaq] = useState([]);
  useEffect(() => {
    api.get("/brand").then((r) => setFaq(r.data.faq || [])).catch(() => setFaq([]));
  }, []);

  return (
    <PublicLayout>
      <section className="container-page py-16 md:py-20">
        <p className="label-caps">FAQ</p>
        <h1 className="h1 mt-2 max-w-2xl">Questions coaches actually ask.</h1>

        <div className="mt-10 max-w-3xl">
          <Accordion type="single" collapsible className="space-y-3">
            {faq.map((item, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="rounded-xl border border-ink-100 bg-white px-5"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="text-left font-heading text-lg font-semibold text-ink-900 hover:no-underline">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-base text-ink-700">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>
    </PublicLayout>
  );
}
